import React, { useState, useEffect } from "react";
import { isEmpty, findIndex, uniqueId } from "lodash";
import { withTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import {
  Paper,
  FormLabel,
  Typography,
  Grid,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  makeStyles
} from "@material-ui/core";

import { Snackbar } from "../../Common/Snackbar";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { Select } from "../../Common/Select";

const DAYSOFWEEKDEFAULT = [
  { id: 1, name: "monday" },
  { id: 2, name: "tuesday" },
  { id: 3, name: "wednesday" },
  { id: 4, name: "thursday" },
  { id: 5, name: "friday" },
  { id: 6, name: "saturday" },
  { id: 0, name: "sunday" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40, 
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20 
  }
}));

const Period = ({ t, i18n, onChangeData, committee, disabled }) => {
  const classes = useStyles();
  const [value, setValue] = useState({});
  const [selectedDuration, setSelectedDuration] = useState("");
  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const { getFrequency, frequency } = useFormCombos();

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });

  const findFrequency = (frequencyName) => findIndex(frequency, ["id", frequencyName]);

  const fillCommittee = (items) => {
    const findFrequencyIdx = findFrequency(items.frequency);

    setValue({
      frequency: findFrequencyIdx !== -1 ? frequency[findFrequencyIdx] : {}
    });

    setDaysOfWeek(items.daysOfWeek.map((item) => item.dayOfWeekId));
    setSelectedDuration(items.duraction);
  };

  useEffect(() => {
    if (!isEmpty(committee)) {
      fillCommittee(committee);
    }
  }, [committee]);

  useEffect(() => {
    if (i18n.language) {
      getFrequency(i18n.language);
    }
  }, [i18n.language]);

  useEffect(() => {
    onChangeData({
      daysOfWeek,
      duraction:selectedDuration,
      ...value,
    });
  }, [selectedDuration, daysOfWeek, value]);

  const handleChange = (event) => {
    setSelectedDuration(event.target.value);
  }

  const handleChangeCheckbox = (_event, idDay) => {
    const newDaysOfWeek = [...daysOfWeek];
    let isvalid = true;
    const index = newDaysOfWeek.indexOf(idDay);

    if(value.frequency.id == 'S' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    }
    if( value.frequency.id == 'M' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    } 
    if( value.frequency.id == 'Q' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    }
    if( value.frequency.id == 'B' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    }
    if( value.frequency.id == 'T' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    }
    if( value.frequency.id == 'A' && newDaysOfWeek.length >= 1 && index === -1)
    {
    MessageFrequency();
    isvalid = false;
    }
  
  if(isvalid){
    const idx = findIndex(daysOfWeek, (item) => {
    
      return item == idDay;
    });
    if (idx !== -1) newDaysOfWeek.splice(idx, 1);
    else newDaysOfWeek.push(idDay);

    setDaysOfWeek(newDaysOfWeek);
  }
  };

  const MessageFrequency = () => {
    setMessage({
      open: true,
      content:"A frequência selecionada não permite marca mais de um dia da semana",
      type: "error",
      autoHideDuration: null,
    });
 }
  
  const handleChangeSelect = (selected, name) => {
    if(selected === null) {
      if(name === "frequency") {
        setValue({ ...value, [name]: ""} );
      }
    } else {
      setValue({ ...value, [name]: selected });
    }
  };

  const findDayChecked = (idDay) => {
    const idx = findIndex(daysOfWeek, (item) => {
      return item == idDay;
    });
    return idx !== -1;
  };

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {t("forms.committee.period")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Grid item lg={12} style={{ marginBottom: 20 }}>
            <Select
              id="frequency"
              options={frequency}
              value={value.frequency}
              setValue={(value) => handleChangeSelect(value, "frequency")}
              label={t("forms.committee.frequency")}
              disabled={disabled}
              error={ value.frequency ? false : true }
              required={true}
            />
          </Grid>
          <Grid item lg={12} style={{ marginBottom: 20 }}>
            <InputMask
              mask="99:99"
              maskChar=""
              onChange={handleChange}
              value={selectedDuration}
              disabled={disabled}
            >
              {() => (
                <TextField
                  name="code"
                  inputProps={{
                    id: "code",
                  }}
                  label={t("forms.committee.duration")}
                  disabled={disabled}
                  fullWidth
                  required
                  error={selectedDuration ? false : true}
                />
              )}
            </InputMask>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend" style={{ marginBottom: 20 }}>
              {t("forms.committee.daysOfWeek.title")}
            </FormLabel>
            <FormGroup>
              {DAYSOFWEEKDEFAULT.map((item) => (
                <FormControlLabel
                  key={uniqueId()}
                  control={
                    <Checkbox
                      color="primary"
                      checked={findDayChecked(item.id)}
                      onChange={(event) => handleChangeCheckbox(event, item.id)}
                      name={item.name}
                      disabled={disabled}
                    />
                  }
                  label={t(`forms.committee.daysOfWeek.${item.name}`)}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Snackbar
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
      />
    </Paper>
    
  );
};

export default withTranslation()(Period);
